import { enums, Infer } from "superstruct";

export const FirebaseOrderByDirectionStruct = enums(["desc", "asc"]);

export type FirebaseOrderByDirection = Infer<
  typeof FirebaseOrderByDirectionStruct
>;
